// Paneles que se guardan en el ajuste de una opción.
// Con baterías por opción (verificador de la E6, 25-oct): si el vendedor solo escribe el precio, ese precio es para los
// paneles que VE en la tarjeta; el motor pudo subirlos al mínimo que recibe el híbrido, y un ajuste sin paneles lo lee como
// precio para los paneles de antes y lo descarta («Llévalo a verde» no hacía nada). Por eso se guardan los que ve.
// Sin baterías, igual que siempre: sin paneles escritos, el ajuste no fija paneles.
export function panelesDelAjuste(escritos: number | null, conPrecio: boolean, conBaterias: boolean, losQueVe: number): number | null {
  if (escritos !== null) return escritos;
  return conBaterias && conPrecio ? losQueVe : null;
}
